import { SCREEN_SIZE } from 'types';
import { BasemapSession } from 'utilities/basemap-session.util';

export interface ActionTypes {
  SET_USER_SESSION: string;
  SET_AUTHENTICATED: string;
  SESSION_START: string;
  SESSION_END: string;
  SET_SESSION_USER_NAME: string;
  SET_SESSION_USER_ORGANISATION: string;
  SET_IS_USER_REG: string;
  SESSION_INIT: string;
  SET_SCREEN_SIZE: string;
  SET_IS_FROM_SWXLOCATE: string;
  SET_REDIRECT_PATH: string;
  SET_BASEMAP_SESSION: string;
  SET_PURCHASED_AUTHORISATION: string;
}

export const SessionActionTypes: ActionTypes = {
  SESSION_INIT: '@@SESSION_INIT',
  SESSION_START: '@@SET_START_SESSION',
  SESSION_END: '@@SET_END_SESSION',
  SET_SESSION_USER_NAME: '@@SET_SESSION_USER_NAME',
  SET_SESSION_USER_ORGANISATION: '@@SET_SESSION_USER_ORGANISATION',
  SET_AUTHENTICATED: '@@SET_AUTHENTICATED',
  SET_USER_SESSION: '@@SET_USER_SESSION',
  SET_IS_USER_REG: '@@SET_IS_USER_REG',
  SET_SCREEN_SIZE: '@@SET_SCREEN_SIZE',
  SET_IS_FROM_SWXLOCATE: '@@SET_IS_FROM_SWXLOCATE',
  SET_REDIRECT_PATH: '@@SET_REDIRECT_PATH',
  SET_BASEMAP_SESSION: '@@SET_BASEMAP_SESSION',
  SET_PURCHASED_AUTHORISATION: '@@SET_PURCHASED_AUTHORISATION'
};

export interface SessionState {
  session: boolean;
  isAuthenticated?: boolean;
  isRegistered?: boolean;
  currentUser?: any;
  sessionExpiryIn?: number;
  screenSize?: SCREEN_SIZE;
  isFromSwxLocate?: boolean;
  redirectPath?: string;
  basemapSession?: BasemapSession | null;
  purchasedAuthorisation?: {
    type: string;
    newBalance: number;
    previousBalance: number;
    expiredAt: string;
  };
}
